export default {
  'goldkid-advantage:title': 'С Kaspi Gold для ребенка Вы сможете:',
  // 'goldkid-advantage:description': 'для получения пособий и соц.выплат',
  'goldkid-advantage:advantage-1': 'Переводить Вашему ребенку деньги на карманные расходы',
  'goldkid-advantage:img-alt-1': 'Переводить Вашему ребенку деньги на карманные расходы',
  'goldkid-advantage:advantage-2': 'Контролировать траты ребенка',
  'goldkid-advantage:img-alt-2': 'Контролировать траты ребенка',
  'goldkid-advantage:advantage-3': 'Управлять доступом на покупки в интернете по его карте',
  'goldkid-advantage:img-alt-3': 'Управлять доступом на покупки в интернете по его карте'
}
